/**
 * Format THC/CBD pourcentage
 */
exports.formatTotalPercentage = value =>
  value !== undefined ? `${Math.round(value)}%` : null;
